import { useState } from 'react'

import useStyles from './InfiniteListWrapper.styles'

interface InfiniteListWrapperProps {
  children: (props: { stickedHeader: boolean }) => React.ReactNode
}

const InfiniteListWrapper = ({ children }: InfiniteListWrapperProps) => {
  const classes = useStyles()
  const [stickedHeader, setStickedHeader] = useState(false)

  const handleScroll = (e: React.UIEvent<HTMLDivElement, UIEvent>) =>
    setStickedHeader(e.currentTarget.scrollTop > 0)

  return (
    <div className={classes.wrapper}>
      <div className={classes.content} onScroll={handleScroll}>
        {children({ stickedHeader })}
      </div>
    </div>
  )
}

export default InfiniteListWrapper
